import React, { useState, useEffect, useCallback, useMemo } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";

import { SpokenLanguageShower } from '../../../features/viewfeatures/SpokenLanguageShower';

export function TeacherTranslationSelectLanguage () {
	
	const [ loading, setLoading ] = useState(true);
	const [ error, setError ] = useState(null);
	const [ languages, setLanguages ] = useState([]);
	const [ translatorLanguages, setTranslatorLanguages ] = useState([]);
	
	const username = useSelector(state => state.usermangement.username);
	const password = useSelector(state => state.usermangement.password);
	
	const getMyHeaders = useCallback(() => {
		
		let returnValue = new Headers();
		returnValue.append("Content-Type", "application/json");
		
	}, []);
	
	const getRaw = useCallback(() => {
		
		return JSON.stringify({
			"mailaddress": username,
			"password": password
		});
		 
	}, [username, password]);
	
	var myHeaders = useMemo(() => getMyHeaders(), [getMyHeaders]); 
	var raw = useMemo(() => getRaw(), [getRaw]);
	
	useEffect(() => {
		
		document.title = 'Cobtras - Translation select language';

		const toastid = toast.loading('Loading data ...');

		var requestOptions = {
  			method: 'POST',
  			headers: myHeaders,
  			body: raw,
  			redirect: 'follow'
		};
		
		let avaiableLanguagesObjects = [];

		fetch("https://cobtras.com/api/v1/translator/" + username, requestOptions)
  			.then(response => response.text())
  			.then((result) => {
				
				let translatorLanguages = JSON.parse(result);
				
				for(let i = 0; i < translatorLanguages.length; i++){
					avaiableLanguagesObjects.push(translatorLanguages[i][1]);
				}
				
				fetch("https://cobtras.com/api/v1/signlanguages", requestOptions)
  					.then(response => response.text())
  					.then((result) => {
				
					let resultObj = JSON.parse(result);
					
					for(let i = 0; i < resultObj.length; i++){
						
						for(let i2 = 0; i2 < translatorLanguages.length; i2++){
							
							if(resultObj[i].id === translatorLanguages[i2][0]){
								
								avaiableLanguagesObjects.push(resultObj[i].commonSpokenLanguage);
								
								
							}
							
						}
						
					}
					
					setTranslatorLanguages([...new Set(avaiableLanguagesObjects.map(item => item))]);
					
					fetch("https://cobtras.com/api/v1/spokenlanguages", requestOptions)
  						.then(response => response.text())
  						.then((result) => {
				
							setLanguages(JSON.parse(result));
				
							setLoading(false);
							setError(null);
				
							toast.update(toastid, { render: "Successful loaded data", type: "success", isLoading: false, autoClose: 5000 });
							
						})
						.catch((err) => { 
				
							setLanguages(null);
							setError(err.message);
							setLoading(false);
				
							toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
				
						});
					
				})
				.catch((err) => { 
				
					setError(err.message);
					setLoading(false);
				
					toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
				
				});
					  
			})
			.catch((err) => { 
				
				setError(err.message);
				setLoading(false);
				
				toast.update(toastid, { render: "Error: " + err, type: "error", isLoading: false, autoClose: 5000 });
				
			});
		
	}, [setError, myHeaders, raw, setLoading, username]);
	
	return (
		<div class="clearfix">
			<div class="detail">
				<h1>Translations</h1>
				{loading && <p>Loading data...</p>}
      			{error && (
			        <p>{`There is a problem fetching the post data - ${error}`}</p>
      			)}
      			{!loading && 
      				<>
      					<h2>Please select a sign language</h2>
      					<ul className="listul">
							{translatorLanguages.map((languageCombination) => (
								<li key={languageCombination}>
									<Link to={`/teachertranslations/${languageCombination}`}>
										<SpokenLanguageShower value={languageCombination} list={languages} />
									</Link>
								</li>
							))}
      					</ul>
      				</>
      			}
				<ToastContainer />
			</div>
		</div>
	);
	
}